<div class="summary">

  <div class="summary__wrapper d-flex v-scrollbar" 
  [class.justify-content-center]="!showPrices">
    <div class="summary__left">
      <h3 class="fw-500 fz-24 lh-32">{{ 'Shared.Title.Products_summary' | translate }}</h3>
    
      <div class="d-flex flex-column" [class.d-none]="loading">
        <ng-container *ngIf="!savedCategories; else savedCategoriesBLock">
          <ng-container *ngFor="let category of categories; let i = index">
            <div *ngIf="category.products?.length" class="summary__category d-inline-flex w-100 mt-24">
              <div class="d-flex flex-column w-100">
                <div class="d-flex justify-content-between align-items-center pb-16">
                  <h3 #categoryName class="fz-18 fw-500 lh-24 capitalize ellipsis" [ngbTooltip]="category.name"
                    [openDelay]="tooltipOpenDelay" [disableTooltip]="categoryName.clientWidth >= categoryName.scrollWidth"
                    triggers="hover touchstart" container="body">
                    {{ category.name }}
                  </h3>
                </div>
    
                <div *ngIf="category.products?.length" class="summary__products-wrapper">
                    <ng-container *ngFor="let item of category.products; let last = last">
                      <div class="summary__item d-flex flex-column cursor-pointer">
                        <div class="d-flex justify-content-between align-items-center gap-8">
                          <div class="d-flex align-items-center min-w-0 images-block w-100">
                            <div class="mr-16 br-8 image-icon-wrapper" [class.no-border]="item.itemType === wishlistItemType.NoStandardDelivery || item.preview === 'assets/no_images.png'
                             || item.preview === 'assets/no_images_placeholder.svg'">
                              <img [ngClass]="
                                item.preview === 'assets/no_images.png' ? 'object-fit-cover' : 'object-fit-contain'
                              " width="48" height="48" [src]="
                                item.itemType === wishlistItemType.NoStandardDelivery
                                  ? '/assets/prohibit-icon.svg'
                                  : item.preview
                              " alt="icon" />
                            </div>
                            <div class="d-flex flex-column min-w-320 mr-8">
                              <div>
                                <div class="d-flex align-items-center min-w-0">
                                  <p #title class="fz-16 lh-24 ellipsis product-name mr-8" [ngbTooltip]="item.title"
                                    [openDelay]="tooltipOpenDelay" [disableTooltip]="title.clientWidth >= title.scrollWidth"
                                    triggers="hover touchstart" container="body">
                                    {{ item.title }}
                                  </p>
                                </div>
      
                                <div class="d-flex min-w-0 fz-16 lh-24 summary__item-desktop-cont text-gray-890">
                                  <div #typeName class="d-block ellipsis" [ngbTooltip]="item.productTypeName"
                                    [openDelay]="tooltipOpenDelay"
                                    [disableTooltip]="typeName.clientWidth >= typeName.scrollWidth"
                                    triggers="hover touchstart">{{ item.type?.title }}</div>
      
                                  <ng-container *ngIf="item.priceType === priceType.Fixed && item.quantity">
                                    <span class="ml-4 mr-4">&bull;</span>
                                    <span class="white-space-nowrap">
                                      {{ item.quantity }}
                                      {{
                                        !item.quantity || item.quantity > 1
                                          ? ('Shared.Entity.Summary_items' | translate | lowercase)
                                          : ('Shared.Entity.Summary_item' | translate | lowercase)
                                       }}
                                    </span>
                                  </ng-container>
      
                                </div>
      
                              </div>
                            </div>
      
                            <div
                              class="d-flex flex-column min-w-0 fz-16 lh-24 summary__item-mobile-cont summary__item-mobile-bottom-bar w-100">
                              <div class="d-flex">
                              
                              </div>
      
                              <div class="d-flex flex-column bottom-bar">
                                <div class="d-flex">
                                  <div *ngIf="item.id" class="w-100">
                                    <ng-container *ngIf="item.standard; else notStandardBlock">
                                      <div class="d-inline-flex w-100 justify-content-between">
                                        <div class="d-inline-flex w-50 justify-content-center">
                                          <div class="mr-4">{{ 'Shared.Entity.Standart' | translate }}</div>
                                        </div>
                                        <div class="price-block mr-2" *ngIf="showPrices">{{ item.fullPrice | customDecimal }},-</div>
                                      </div>
                                    </ng-container>
                                  </div>
      
                                  <ng-template #notStandardBlock>
                                   
                                    <div *ngIf="item.price !== 0; else freeOption">
                                      <div class="d-inline-flex w-100 justify-content-between">
                                        <div class="d-inline-flex w-50 justify-content-center">
                                          <div class="type-cell">{{ 'Shared.Entity.Option' | translate }}</div>
                                        </div>
                                    
                                        <div class="price-block" *ngIf="showPrices">
    
                                          <p class="fz-16 lh-24">{{ item.price | customDecimal }},-</p>
                                        </div>
                                      </div>
                                    </div>
      
                                    <ng-template #freeOption>
                                      <div class="d-inline-flex w-100 justify-content-between">
                                        <div class="d-inline-flex w-50 justify-content-center">
                                          <div class="type-cell">{{ 'Title.Cost_free_option' | translate }}</div>
                                        </div>
                                    
                                        <div *ngIf="showPrices" class="price-block mr-2">{{ item.fullPrice | customDecimal }},-</div>
                                      </div>
                                    </ng-template>
                                  </ng-template>
      
                                  <span *ngIf="item.productTypeDueDate"
                                    class="white-space-nowrap lh-24 summary__item-desktop-cont">
                                    {{ 'Shared.Title.Due' | translate }}
                                    {{ item.productTypeDueDate | date: 'dd.MM' }}
                                  </span>
                                </div>
      
                              </div>
                            </div>
                          </div>
                        </div>
      
                  
                      </div>
                    </ng-container>
          
                  </div>
                </div>
              </div>
              
            </ng-container>

        </ng-container>
          <ng-template #savedCategoriesBLock>
            <ng-container *ngFor="let category of savedCategories; let i = index">
              <div *ngIf="category.products?.length" class="summary__category d-inline-flex w-100 mt-24">
                <div class="d-flex flex-column w-100">
                  <div class="d-flex justify-content-between align-items-center pb-16">
                    <h3 #categoryName class="fz-18 fw-500 lh-24 capitalize ellipsis" [ngbTooltip]="category.category.name"
                      [openDelay]="tooltipOpenDelay" [disableTooltip]="categoryName.clientWidth >= categoryName.scrollWidth"
                      triggers="hover touchstart" container="body">
                      {{ category.category.name }}
                    </h3>
                  </div>
      
                  <div *ngIf="category.products?.length" class="summary__products-wrapper">
                      <ng-container *ngFor="let item of category.products; let last = last">
                        <div class="summary__item d-flex flex-column cursor-pointer">
                          <div class="d-flex justify-content-between align-items-center gap-8">
                            <div class="d-flex align-items-center min-w-0 images-block w-100">
                              <div class="mr-16 br-8 image-icon-wrapper">
                                <img [ngClass]="
                                  item.preview === 'assets/no_images.png' ? 'object-fit-cover' : 'object-fit-contain'
                                " width="48" height="48" [src]="
                                  !item.id
                                    ? '/assets/prohibit-icon.svg'
                                    : item.preview.filename?.w260?.url || 'assets/no_images.png'
                                " alt="icon" />
                              </div>
                              <div class="d-flex flex-column min-w-320 mr-8">
                                <div>
                                  <div class="d-flex align-items-center min-w-0">
                                    <p #title class="fz-16 lh-24 ellipsis product-name mr-8" [ngbTooltip]="item.title"
                                      [openDelay]="tooltipOpenDelay" [disableTooltip]="title.clientWidth >= title.scrollWidth"
                                      triggers="hover touchstart" container="body">
                                      {{ item.title }}
                                    </p>
                                  </div>
        
                                  <div class="d-flex min-w-0 fz-16 lh-24 summary__item-desktop-cont text-gray-890">
                                    <div #typeName class="d-block ellipsis" [ngbTooltip]="item.layoutProductType?.name"
                                      [openDelay]="tooltipOpenDelay"
                                      [disableTooltip]="typeName.clientWidth >= typeName.scrollWidth"
                                      triggers="hover touchstart">{{ item.layoutProductType?.name }}</div>
        
                                    <ng-container *ngIf="item.layoutProductType.show_quantity">
                                      <span class="ml-4 mr-4">&bull;</span>
                                      <span class="white-space-nowrap">
                                        {{ item.layoutProductType?.quantity }}
                                        {{
                                          !item.layoutProductType.quantity || item.layoutProductType.quantity > 1
                                            ? ('Shared.Entity.Summary_items' | translate | lowercase)
                                            : ('Shared.Entity.Summary_item' | translate | lowercase)
                                         }}
                                      </span>
                                    </ng-container>
        
                                  </div>
        
                                </div>
                              </div>
        
                              <div
                                class="d-flex flex-column min-w-0 fz-16 lh-24 summary__item-mobile-cont summary__item-mobile-bottom-bar w-100">
                                <div class="d-flex">
                                </div>
        
                                <div class="d-flex flex-column bottom-bar">
                                  <div class="d-flex">
                                    <div *ngIf="item.itemType !== wishlistItemType.NoStandardDelivery; else optionalBlock" class="w-100">
                                      <ng-container *ngIf="item.standard; else notStandardBlockItem">
                                        <div class="d-inline-flex w-100 justify-content-between">
                                          <div class="d-inline-flex w-50 justify-content-center">
                                            <div class="mr-4">{{ 'Shared.Entity.Standart' | translate }}</div>
                                          </div>
                                        
                                          <div class="price-block mr-2" *ngIf="showPrices">{{ item.fullPrice | customDecimal }},-</div>
                                        </div>
                                      </ng-container>
                                    </div>
        
                                    <ng-template #notStandardBlockItem>
                                     
                                      <div *ngIf="item.price !== 0; else freeOption">
                                        <div class="d-inline-flex w-100 justify-content-between">
                                          <div class="d-inline-flex w-50 justify-content-center">
                                            <div class="type-cell">{{ 'Shared.Entity.Option' | translate }}</div>
                                          </div>
                                  
                                          <div class="price-block" *ngIf="showPrices">
      
                                            <p class="fz-16 lh-24">{{ item.fullPrice | customDecimal }},-</p>
                                          </div>
                                        </div>
                                      </div>
        
                                      <ng-template #freeOption>
                                        <div class="d-inline-flex w-100 justify-content-between">
                                          <div class="d-inline-flex w-50 justify-content-center">
                                            <div class="type-cell">{{ 'Title.Cost_free_option' | translate }}</div>
                                          </div>
                                 
                                          <div *ngIf="showPrices" class="price-block mr-2">0,-</div>
                                        </div>
                                      </ng-template>
                                    </ng-template>
        
                                    <span *ngIf="item.productTypeDueDate"
                                      class="white-space-nowrap lh-24 summary__item-desktop-cont">
                                      {{ 'Shared.Title.Due' | translate }}
                                      {{ item.productTypeDueDate | date: 'dd.MM' }}
                                    </span>
                                  </div>
        
                                </div>
                              </div>
                            </div>
                          </div>
        
                
                        </div>
                      </ng-container>
            
                    </div>
                  </div>
                </div>
                
              </ng-container>
            

          </ng-template>
      </div>
    </div>

    <div class="summary__right d-flex flex-column" *ngIf="showPrices">
      <h3 class="fw-500 lh-32 fz-24 mb-12">{{ 'Shared.Title.Price_summary' | translate }}</h3>

      <ng-container *ngIf="!savedCategories; else savedCategoriesBloclPrices">
        <ng-container *ngFor="let category of categories">
          <div class="d-inline-flex justify-content-between summary__category-item m-w-0 w-100s">
            <p #name class="fz-16 lh-24 d-block ellipsis" [ngbTooltip]="category.name" [openDelay]="tooltipOpenDelay"
              [disableTooltip]="name.clientWidth >= name.scrollWidth" triggers="hover touchstart">
              {{ category.name | truncate: truncateLimit }}
            </p>
            <p *ngIf="showPrices" class="fz-16 lh-24 flex-shrink-0">{{ (category?.totalPrice || 0) | customDecimal }},-</p>
          </div>
  
        </ng-container>

      </ng-container>

      <ng-template #savedCategoriesBloclPrices>
        <ng-container *ngFor="let cat of savedCategories">
          <div class="d-inline-flex justify-content-between summary__category-item m-w-0 w-100s">
            <p #name class="fz-16 lh-24 d-block ellipsis" [ngbTooltip]="cat.category.name" [openDelay]="tooltipOpenDelay"
              [disableTooltip]="name.clientWidth >= name.scrollWidth" triggers="hover touchstart">
              {{ cat.category.name | truncate: truncateLimit }}
            </p>
            <p *ngIf="showPrices" class="fz-16 lh-24 flex-shrink-0">{{ (cat.totalPrice || 0) | customDecimal }},-</p>
          </div>
  
        </ng-container>
      </ng-template>

      <div class="d-inline-flex justify-content-between summary__options--total">
        <div class="d-flex align-items-center">
          <h3 class="fw-500 fz-18 lh-24">{{ 'Shared.Title.Total_selected' | translate }}</h3>

        </div>
        <div class="d-flex align-items-center">
          <h3 *ngIf="showPrices" class="fw-500 fz-18 lh-24">{{ totalPrice | customDecimal }},-</h3>
        </div>
      </div>
    </div>
  </div>

</div>